// 动态家在状态
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const files = require.context('./modules', false, /\.js$/)
let modules = {}

// 动态加载vuex
files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
// console.log('msbslib store', msbsLib.store)
modules = { ...modules }
export default new Vuex.Store({
  modules,
  getters: {
    token: state => state.user.token,
    roles: state => state.user.userInfo.roles,
    userInfo: state => state.user.userInfo,
    selectedDocId: state => state.user.selectedDocId,
    selectedDocName: state => state.user.selectedDocName
  }
})
